<template>
  <router-link
    v-if="FromDevicePartial"
    :to="{
      name: 'Site_DeviceEdit',
      params: { dev_id: dev_id }
    }"
  >
    <svg
      class="fill-current w-3.5 text-white hover:text-flyingeye-light transition-all "
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.70001 79.3H65.9C68.287 79.3 70.5761 78.3518 72.264 76.664C73.9518 74.9761 74.9 72.687 74.9 70.3V49.1C74.9 48.3044 74.5839 47.5413 74.0213 46.9787C73.4587 46.4161 72.6957 46.1 71.9 46.1C71.1123 46.125 70.3637 46.4491 69.8064 47.0064C69.2491 47.5637 68.925 48.3123 68.9 49.1V70.3C68.914 70.6977 68.8459 71.0941 68.7001 71.4644C68.5543 71.8347 68.3338 72.171 68.0524 72.4524C67.771 72.7338 67.4347 72.9543 67.0644 73.1001C66.6941 73.2459 66.2977 73.314 65.9 73.3H9.70001C9.30228 73.314 8.90594 73.2459 8.53564 73.1001C8.16535 72.9543 7.82903 72.7338 7.54762 72.4524C7.26621 72.171 7.04573 71.8347 6.89991 71.4644C6.75409 71.0941 6.68604 70.6977 6.70001 70.3V14.1C6.68604 13.7023 6.75409 13.3059 6.89991 12.9356C7.04573 12.5653 7.26621 12.229 7.54762 11.9476C7.82903 11.6662 8.16535 11.4457 8.53564 11.2999C8.90594 11.1541 9.30228 11.086 9.70001 11.1H30.9C31.6877 11.075 32.4363 10.7509 32.9936 10.1936C33.5509 9.63632 33.875 8.88771 33.9 8.1C33.9 7.30435 33.5839 6.54129 33.0213 5.97868C32.4587 5.41607 31.6957 5.1 30.9 5.1H9.70001C7.31306 5.1 5.02388 6.04821 3.33605 7.73604C1.64822 9.42387 0.700012 11.7131 0.700012 14.1V70.3C0.700012 72.687 1.64822 74.9761 3.33605 76.664C5.02388 78.3518 7.31306 79.3 9.70001 79.3Z" />
      <path
        d="M71.7 3.3C69.9963 1.61453 67.6965 0.669159 65.3 0.669159C62.9035 0.669159 60.6037 1.61453 58.9 3.3L24.7 37.6L22.3 52C22.1579 52.784 22.2015 53.5903 22.4273 54.3544C22.653 55.1185 23.0547 55.8191 23.6 56.4C24.5863 57.2946 25.8684 57.7932 27.2 57.8H28L42.4 55.3L76.7 21.1C78.3618 19.3839 79.2909 17.0888 79.2909 14.7C79.2909 12.3112 78.3618 10.0161 76.7 8.3L71.7 3.3ZM67.4 7.5L72.5 12.6C73.0287 13.1699 73.3155 13.9228 73.3 14.7C73.296 15.4737 73.0118 16.2197 72.5 16.8L72.3 17L63 7.7L63.2 7.5C63.7723 6.97293 64.522 6.68035 65.3 6.68035C66.0781 6.68035 66.8277 6.97293 67.4 7.5ZM39.5 49.7L28.4 51.6L30.3 40.5L58.7 12L68 21.3L39.5 49.7Z" />
    </svg>
  </router-link>

  <router-link
    v-else
    :to="{ name: 'Site_DeviceEdit', params: { dev_id: dev_id } }"
    @click.stop=""
    class="absolute top-[8px]"
    :class="CssClass"
  >
    <svg
      class="w-[15px] fill-current"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 399.8 410.05"
    >
      <path
        d="M199.9,150.35h0c-30.2,0-54.67,24.48-54.67,54.67s24.48,54.67,54.67,54.67,54.67-24.48,54.67-54.67-24.48-54.67-54.67-54.67Z"
      />
      <path
        d="M392.98,253.19s-.06-.03-.08-.05l-44.42-25.7c2.35-14.99,2.35-30.25,0-45.24l44.42-25.7c6.56-3.74,8.84-12.09,5.1-18.64-.02-.03-.03-.06-.05-.08l-41.01-71.07c-3.74-6.56-12.09-8.84-18.64-5.1-.03.01-.05.03-.08.05l-44.56,26.11c-11.79-9.56-24.97-17.26-39.09-22.83V13.67c0-7.55-6.12-13.67-13.67-13.67h-82.01c-7.55,0-13.67,6.12-13.67,13.67v51.26c-14.12,5.57-27.31,13.26-39.09,22.83l-44.56-25.7c-6.53-3.78-14.89-1.56-18.68,4.97-.02.03-.03.06-.05.08L1.84,138.19c-3.78,6.53-1.56,14.89,4.97,18.68.03.02.06.03.08.05l44.43,25.7c-2.35,14.99-2.35,30.25,0,45.24l-44.43,25.56c-6.51,3.75-8.77,12.05-5.06,18.59l41,71.08c3.74,6.56,12.09,8.84,18.64,5.1.03-.02.06-.03.08-.05l44.56-25.7c11.79,9.52,24.98,17.17,39.09,22.69v51.26c0,7.55,6.12,13.67,13.67,13.67h82.01c7.55,0,13.67-6.12,13.67-13.67v-51.25c14.12-5.56,27.31-13.26,39.09-22.83l44.56,25.7c6.53,3.78,14.89,1.56,18.68-4.97.02-.03.03-.06.05-.08l41-71.08c3.78-6.53,1.56-14.89-4.97-18.68ZM199.9,287.04c-45.29,0-82.01-36.72-82.01-82.01h0c0-45.29,36.72-82.01,82.01-82.01s82.01,36.72,82.01,82.01-36.72,82.01-82.01,82.01Z"
      />
    </svg>
  </router-link>
</template>

<script>
export default {
  name: "Device_Link",
  props: {
    dev_id: {
      type: Number,
      required: true,
    },
    CssClass: {
      type: String,
    },
    FromDevicePartial: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
